var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { SubtopicQuestions } from './modules/SubtopicQuestions';
import { cachedSet } from '../../../utils/mobx/decorators/customComputed';
export class Subtopic {
    type = 'subtopic';
    parent;
    name = '';
    constructor(parent, name) {
        makeObservable(this);
        this.parent = parent;
        this.name = name;
    }
    subtopicQuestions = new SubtopicQuestions(this);
    get topic() {
        return this.parent;
    }
    get app() {
        return this.topic.context.app;
    }
    get microQuestions() {
        return this.topic.topicMicroQuestions.microQuestions.filter(micro => micro.subtopicName === this.name);
    }
    get count() {
        return this.microQuestions.length;
    }
    get miniQuestionsOfThisTag() {
        return this.topic.topicMiniQuestions.miniQuestions.filter(mini => mini.subtopicName === this.name);
    }
    get numberOfQuestionsOfThisTag() {
        return this.miniQuestionsOfThisTag.length;
    }
}
__decorate([
    cachedSet
], Subtopic.prototype, "miniQuestionsOfThisTag", null);
__decorate([
    computed
], Subtopic.prototype, "numberOfQuestionsOfThisTag", null);
